export default "__VITE_ASSET__Y3eo57GQ__"